var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.4419 5.44194C12.686 5.19786 12.686 4.80214 12.4419 4.55806L8.46447 0.580583C8.22039 0.336505 7.82466 0.336505 7.58058 0.580583C7.3365 0.82466 7.3365 1.22039 7.58058 1.46447L11.1161 5L7.58058 8.53553C7.3365 8.77961 7.3365 9.17534 7.58058 9.41942C7.82466 9.6635 8.22039 9.6635 8.46447 9.41942L12.4419 5.44194ZM0 5.625L12 5.625V4.375L0 4.375L0 5.625Z","fill":"white"}));
}

Arrow.defaultProps = {"width":"13","height":"10","viewBox":"0 0 13 10","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
